import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';


i18n
.use(HttpApi)
  .use(LanguageDetector) // Detects language from localStorage, browser, etc.
  .use(initReactI18next)
  .init({
    backend: {
        loadPath: '/locales/{{lng}}.json', // Path to your translation files
      },
    fallbackLng: "en", // Default language
    interpolation: { escapeValue: false }, // React already escapes values
    ns: ['pageTitle', 'common'], // Define namespaces
    defaultNS: 'common', // Default namespace
    detection: {
      order: ["localStorage", "navigator"], // Detect language from localStorage first
      caches: ["localStorage"], // Save selected language in localStorage
    },
  });

export default i18n;
